import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import HistoryIcon from '@material-ui/icons/History';
import { BoxStatus } from 'home/useSubBoxStatuses';
import { Box } from 'home/useBoxes';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import { AppPath } from 'AppRoutes';
import { getQueryString } from './useMsgs';
import Tooltip from '@material-ui/core/Tooltip';

interface Props {
  status: BoxStatus;
  box: Box;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: { color: theme.palette.info.dark },
}));

const LogButton = ({ status, box }: Props) => {
  const classes = useStyles();

  const navigate = useNavigate();
  const onClick = () =>
    navigate(`/${AppPath.Log}/${box.id}${getQueryString()}`);

  return status.updatedAt ? (
    <Tooltip title='履歴'>
      <IconButton aria-label='history' color='secondary' onClick={onClick}>
        <HistoryIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  ) : null;
};

export default LogButton;
